// Who is this player? A random id in a cookie + localStorage, a name and a cab colour, plus lifetime stats.

export const CAB_COLOURS = ['F2B90C', 'E5433A', '3E8BFF', '4CC26B', '9B5DE5', 'FF7A1A', 'FF6BB5', 'F5F1E8'] as const;

export interface Stats { games: number; wins: number; bestHaul: number; karmaLow: number; karmaHigh: number; }
export interface Identity { id: string; name: string; colour: string; stats: Stats; created: number; }

const KEY = 'cab.identity';
const COOKIE = 'cab_id';

function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}
function writeCookie(name: string, value: string): void {
  const expires = new Date(Date.now() + 400 * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}
function randomId(): string {
  const a = new Uint8Array(8); crypto.getRandomValues(a);
  return [...a].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export function loadIdentity(): Identity {
  let stored: Identity | null = null;
  try { stored = JSON.parse(localStorage.getItem(KEY) ?? 'null'); } catch { stored = null; }
  const id = stored?.id ?? readCookie(COOKIE) ?? randomId();
  const identity: Identity = {
    id,
    name: stored?.name ?? '',
    colour: stored?.colour ?? CAB_COLOURS[Math.floor(Math.random() * CAB_COLOURS.length)],
    stats: stored?.stats ?? { games: 0, wins: 0, bestHaul: 0, karmaLow: 0, karmaHigh: 0 },
    created: stored?.created ?? Date.now(),
  };
  saveIdentity(identity);
  return identity;
}

export function saveIdentity(identity: Identity): void {
  try { localStorage.setItem(KEY, JSON.stringify(identity)); } catch { /* private mode */ }
  writeCookie(COOKIE, identity.id);
}

export function recordResult(identity: Identity, r: { money: number; won: boolean; karmaMin: number; karmaMax: number }): void {
  const s = identity.stats;
  s.games += 1; if (r.won) s.wins += 1;
  s.bestHaul = Math.max(s.bestHaul, r.money);
  s.karmaLow = Math.min(s.karmaLow, r.karmaMin); s.karmaHigh = Math.max(s.karmaHigh, r.karmaMax);
  saveIdentity(identity);
}
